import React from "react";

export default function EditEventPage() {
    return <div>
        Start page
    </div>
}